Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'

class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewSnapshot
  constructor: (builder) ->
    @text = builder.getText()
    @reviewId = builder.getReviewId()
    @starRating = builder.getStarRating()
    @author = builder.getAuthor()
    @createdAt = builder.getCreatedAt()

  getText: =>
    @text

  getReviewId: =>
    @reviewId

  getStarRating: =>
    @starRating

  getAuthor: =>
    @author

  getCreatedAt: =>
    @createdAt
